import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowDownIcon from '../../../components/icons/ArrowDownIco'
import { LeftSection } from '../../Placement/style'
import { seRuleListWay } from '../action'
import { RightSection } from '../Style/style'
import AlreadySetPopUp from './AlreadySetPopup'
import {
  Box,
  BoxContent,
  DashboardTopHeader,
  DropdownBox,
  DropdownLabel,
  FullDivCenterFlex,
  PrimaryButton,
  SecondaryButton,
  SetRoleDiv,
  SetRoleHeader,
  Span,
  TopHeading,
} from './Dashboard/style'
import NewRuleModal from './NewRuleModal'

export default function RuleHeader({
  cardData,
  degreeStreamMapList,
  createRules,
  ruleOverwrite,
  getInstituteRulesById,
  isDraftRuleExist,
  initialState,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const isNewRule = location.pathname.includes('/setting-new-rule')
  const isRuleCreation = location.pathname.includes('/rule-creation')
  const isDraftPage = location.pathname.includes('/draft-page')
  const isRuleYetToSet = location.pathname?.includes('/yet-to-set-rule')
  const [isRuleExists, setIsRuleExists] = useState(false)
  const [selectedDegreeStreamMap, setSelectedDegreeStreamMap] = useState([])

  const [ruleExistsList, setRuleExistsList] = useState([])

  const checkingButton = isNewRule || isRuleCreation
  const [selected, setSelected] = useState(null)
  const [isOpen, setIsOpen] = useState(false)

  const [degrees, setDegrees] = useState(0)
  const [departments, setDepartments] = useState(0)

  useEffect(() => {
    const selectedCard =
      location.pathname === '/ruleEngine'
        ? 1
        : location.pathname?.includes('/yet-to-set-rule')
        ? 2
        : null
    setSelected(selectedCard)
  }, [location])
  const handlePrimaryCardClick = index => {
    setSelected(index)
    navigate('/ruleEngine')
  }
  const handleSecondaryCardClick = index => {
    setSelected(index)
    navigate('/ruleEngine/yet-to-set-rule')
  }

  const handleNewRulesOpen = async () => {
    dispatch(seRuleListWay(isDraftPage ? true : false))
    if (degreeStreamMapList?.length > 0) {
      let degreeStreamMap = cardData?.yetToSetDegreeDeptIds
        ?.filter(item => degreeStreamMapList.includes(item.id))
        ?.map(data => ({
          degreeId: data?.degreeId,
          streamId: data?.streamId,
        }))
      let payload = {
        degreeStreamMap: degreeStreamMap,
        isExistingDegreeCheck: true,
      }
      const response = await createRules(payload)
      if (response?.status === 200) {
        if (response?.data?.data?.isAlreadyCourseSet) {
          setIsRuleExists(true)
          setRuleExistsList(response?.data?.data?.courseList)
          setSelectedDegreeStreamMap(response?.data?.data?.degreeStreamMapId)
        } else {
          setIsRuleExists(false)
          navigate(`/ruleEngine/rule-creation/${response?.data?.data?.id}`)
        }
      }
      //
    } else {
      setIsOpen(true)
    }
  }

  const handleClickNewRule = () => {
    navigate('/ruleEngine/setting-new-rule')
  }

  const handleBack = () => {
    setIsOpen(false)
  }
  const handleDraftClick = () => {
    if (isDraftPage) {
      navigate('/ruleEngine')
    } else {
      navigate('/ruleEngine/draft-page')
    }
  }

  const subMessage = isDraftPage
    ? initialState
      ? ''
      : 'Here are all the drafts rule sets.'
    : isRuleYetToSet
    ? 'Here are all the degree and department rules that are yet to be set.'
    : initialState
    ? ''
    : 'Here are all the rule sets that are completed'

  return (
    <>
      <TopHeading flexStart>Rule Engine</TopHeading>
      <DashboardTopHeader>
        {isDraftPage ? (initialState ? ' ' : 'Drafts Rules Set') : 'Dashboard'}
      </DashboardTopHeader>
      {!isDraftPage ? (
        <>
          <SetRoleHeader> Set up new rules</SetRoleHeader>
          <SetRoleDiv>
            Here&apos;s an overview of the degrees and departments for which
            rules are set, as well as those for which rules are not set.
          </SetRoleDiv>
          <SetRoleDiv
            style={{ marginBottom: '15px', marginTop: 0, lineHeight: '13px' }}
          >
            You can establish rules here for individual degrees or groups of
            degrees.
          </SetRoleDiv>
          <Box>
            <BoxContent pRight="15px" mRight={'15px'} flex="1 1 auto">
              <Span bold nowrap style={{ paddingBottom: 5 }}>
                Total degrees : <strong>{cardData?.totalDegreeCount}</strong>
              </Span>
              <Span bold nowrap>
                Total departments :
                <strong>{cardData?.totalDepartmentCount}</strong>
              </Span>
            </BoxContent>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <BoxContent
                paddingLeft="5px"
                paddingRight="5px"
                flex="1 1 auto"
                noBorderRight
              >
                <Span bold>
                  <strong>View</strong>
                </Span>
                <Span marginLeft="3px" textAlign="left" nowrap>
                  Rules that are set:
                </Span>
              </BoxContent>
              <BoxContent noBorderRight>
                <DropdownBox
                  selected={selected === 1}
                  onClick={() => handlePrimaryCardClick(1)}
                  readonly={checkingButton}
                >
                  <div>
                    <DropdownLabel selected={selected === 1}>
                      Degrees: {cardData?.ruleSetDegreeCount}
                    </DropdownLabel>
                    <DropdownLabel selected={selected === 1}>
                      Department: {cardData?.ruleSetDepartmentCount}
                    </DropdownLabel>
                  </div>
                  <ArrowDownIcon onClick={() => history.goBack()} />
                </DropdownBox>
              </BoxContent>
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <BoxContent
                paddingLeft="50px"
                paddingRight="5px"
                flex="1 1 auto"
                noBorderRight
              >
                <Span marginLeft="20px" bold>
                  <strong>View</strong>
                </Span>
                <Span marginLeft="20px" textAlign="left" nowrap>
                  Rules yet to be set:
                </Span>
              </BoxContent>

              <BoxContent
                paddingLeft="50px"
                paddingRight="5px"
                marginLeft="80px"
                flex="1 1 auto"
                noBorderRight
              >
                <DropdownBox
                  selected={selected === 2}
                  onClick={() => handleSecondaryCardClick(2)}
                  padding="20px"
                  readonly={checkingButton}
                >
                  <div>
                    <DropdownLabel selected={selected === 2}>
                      Degrees: {cardData?.yetToSetDegreeCount}
                    </DropdownLabel>
                    <DropdownLabel selected={selected === 2}>
                      Department: {cardData?.yetToSetDepartmentCount}
                    </DropdownLabel>
                  </div>

                  <ArrowDownIcon
                    onChange={e => {
                      if (e.target.value === 'degrees') {
                        setDegrees(degrees + 1)
                      } else {
                        setDepartments(departments + 1)
                      }
                    }}
                  />
                </DropdownBox>
              </BoxContent>
            </div>
          </Box>
        </>
      ) : null}

      {!checkingButton && (
        <FullDivCenterFlex initialState={initialState}>
          {!isDraftPage && (
            <SetRoleHeader> {initialState ? '' : 'Rules set'}</SetRoleHeader>
          )}
          <LeftSection centerVertically>
            <SetRoleDiv>{subMessage}</SetRoleDiv>
          </LeftSection>
          <RightSection centerVertically>
            <SecondaryButton
              text={isDraftPage ? 'Back' : 'Draft'}
              onClick={handleDraftClick}
              disabled={isDraftPage ? false : !isDraftRuleExist}
            />
            <PrimaryButton text="Set New Rules" onClick={handleNewRulesOpen} />
          </RightSection>
        </FullDivCenterFlex>
      )}
      {isOpen ? (
        <NewRuleModal
          handleClick={handleClickNewRule}
          handleBack={handleBack}
        />
      ) : null}
      <AlreadySetPopUp
        isOpen={isRuleExists}
        setIsOpen={setIsRuleExists}
        data={ruleExistsList}
        getInstituteRulesById={getInstituteRulesById}
        ruleOverwrite={ruleOverwrite}
        selectedDegreeStreamMap={selectedDegreeStreamMap}
      />
    </>
  )
}
